import { BrowserRouter, Routes, Route } from "react-router-dom";

import Vis from "./components/Vis";
import RemoveAccount from "./components/RemoveAccount/RemoveAccount";
import Policy from "./components/Policy";
import "./App.css";
import Safety from "./components/Safety";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<RemoveAccount />} />
        {/* <Route exact path="/vis" element={<Vis />} /> */}
        <Route exact path="/policy" element={<Policy s={"./policy.html"} />} />
        <Route
          exact
          path="/policyd"
          element={<Policy s={"./policyd.html"} />}
        />
        <Route exact path="/remove_acc" element={<RemoveAccount />} />
        <Route exact path="/safety" element={<Safety s={"./safety.html"} />} />
        <Route
          exact
          path="/safetyd"
          element={<Safety s={"./safetyd.html"} />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
